<div class="ltms-dropdown" #litmscustomdropdown >
  <button class="ltms-dropdown-button" [disabled]="disabled || readonly" [class.open]="isOpen"
    (click)="openDropDown($event)">
    <div class="button-text" [class.placeholder-text]="!(selectedOption && selectedOption.name)">{{preffix}} {{ (selectedOption && selectedOption.name)? selectedOption.name: placeholder }}</div>
    <input id="litmus-dropdown-search" autocomplete="off" (keyup)="filterList($event)" class="search-box" type="text"
      [placeholder]="placeholder" />
    <div class="dropdown-icon">
      <img src="assets/images/menu-down-dark.svg" />
    </div>
  </button>
  <ul [class.show]="isOpen" *ngIf="categorization && list.length" class="ltms-dropdown-categorized-list">
    <li *ngFor="let category of list">
      <div class="dropdown-category">
        <div class="category-title">{{preffix}} {{category.category_name}}</div>
      </div>
      <ul class="ltms-dropdown-sub-list">
        <li *ngFor="let option of category.options" (click)="selectOption($event,option);"
          [class.active]="selectedOption && selectedOption.value &&  option.value === selectedOption.value">
          {{preffix}} {{option.name}}
        </li>
      </ul>
    </li>
  </ul>
  <ul [class.show]="isOpen" *ngIf="!categorization && list.length" class="ltms-dropdown-list">
    <li *ngFor="let option of list" (click)="selectOption($event,option)"
      [class.active]="selectedOption && selectedOption.value && option.value === selectedOption.value">
      {{preffix}}{{option.name}}
    </li>
  </ul>
  <ul [class.show]="isOpen" *ngIf="!list.length" class="ltms-dropdown-list">
    <li class="no-result">
      no data available for selected filter.
    </li>
  </ul>
</div>